import { doRequest } from "utils/core";

const userAPI = {
  getUser: () => {
    const url = `api/monitors/user`;
    return doRequest("get", url);
  },

  checkToken: () => {
    const url = "api/monitors/info";
    return doRequest("get", url);
  },

  logout: () => {
    const url = `api/auth/logout`;
    return doRequest("delete", url, { returnError: false });
  },
};

export default userAPI;
